class Tab {
  public element: HTMLElement;

  public title: HTMLElement;

  public content: HTMLElement;

  public active = false;

  public Classes = {
    content: 'tab__content--active',
    title: 'tab__title--active',
  };

  public Selector = {
    title: '.tab__title',
    content: '.tab__content',
  };

  constructor(element: HTMLElement) {
    this.element = element;
    this.setElements();
    this.setListeners();
  }

  private setElements = () => {
    this.title = this.element.querySelector(this.Selector.title);
    this.content = this.element.querySelector(this.Selector.content);
  };

  private setListeners = () => {
    this.title?.addEventListener('click', this.toggleState);
    window.addEventListener('resize', this.onResize);
  };

  private toggleState = () => {
    if (this.active) {
      this.content.style.maxHeight = null;
      this.title.classList.remove(this.Classes.title);
      this.content.classList.remove(this.Classes.content);
    } else {
      this.title.classList.add(this.Classes.title);
      this.content.classList.add(this.Classes.content);
      this.content.style.maxHeight = `${this.content.scrollHeight}px`;
    }

    this.active = this.active !== true;
  };

  private onResize = () => {
    if (!this.content) return;

    this.content.style.maxHeight = this.active ? `${this.content.scrollHeight}px` : '0px';
  };
}

export default Tab;
